import produce from "immer";

import { QUIZ4_FEEDBACK_ADD, QUIZ4_ONGOING_UPDATE } from "../actions/types";

const initialState = {};

export default (state = initialState, action) => {
  return produce(state, draft => {
    // eslint-disable-next-line
    switch (action.type) {
      case QUIZ4_FEEDBACK_ADD:
        draft = action.payload;
        return draft;
      case QUIZ4_ONGOING_UPDATE:
        console.log("no reducer update");
        break;
    }
  });
};
